import { BaseWebComponentElementFactory } from '../../framework/BaseWebComponentElementFactory';
import {
  WEB_COMPONENT_WIDGET_ACCESS_DATA_PROTECTION,
  WEB_COMPONENT_WIDGET_COMPANY_RISK_SCORE,
  WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS,
  WEB_COMPONENT_WIDGET_INCIDENTS,
  WEB_COMPONENT_WIDGET_INVENTORY,
  WEB_COMPONENT_WIDGET_NETWORK_ATTACK_TECHNIQUES,
  WEB_COMPONENT_WIDGET_OVERVIEW,
  WEB_COMPONENT_WIDGET_REMEDIATION_ACTIONS,
  WEB_COMPONENT_WIDGET_THREATS_BREAKDOWN,
  WEB_COMPONENT_WIDGET_TOP_THREATS,
  WEB_COMPONENT_WIDGET_WEBSITES_BLOCKED,
  WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS_DETAILS,
} from '../../webcomponents.constants';
import { WidgetType } from '@nirvana/shared/dtos/types/dashboards/common';

export class WidgetElementFactory extends BaseWebComponentElementFactory {
  constructor() {
    super();
    this.map = new Map<string | number, string>([
      [WidgetType.OVERVIEW, WEB_COMPONENT_WIDGET_OVERVIEW],
      [WidgetType.TOP_TYPES_THREATS_BLOCKED, WEB_COMPONENT_WIDGET_TOP_THREATS],
      [WidgetType.THREATS_BREAKDOWN, WEB_COMPONENT_WIDGET_THREATS_BREAKDOWN],
      [WidgetType.INCIDENTS_STATUS, WEB_COMPONENT_WIDGET_INCIDENTS],
      [WidgetType.REMEDIATION_ACTIONS, WEB_COMPONENT_WIDGET_REMEDIATION_ACTIONS],
      [WidgetType.INVENTORY, WEB_COMPONENT_WIDGET_INVENTORY],
      [WidgetType.ACCESS_DATA_PROTECTION, WEB_COMPONENT_WIDGET_ACCESS_DATA_PROTECTION],
      [WidgetType.ENDPOINT_MODULES_STATUS, WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS],
      [WidgetType.COMPANY_RISK_SCORE, WEB_COMPONENT_WIDGET_COMPANY_RISK_SCORE],
      [WidgetType.WEBSITES_BLOCKED, WEB_COMPONENT_WIDGET_WEBSITES_BLOCKED],
      [WidgetType.NETWORK_ATTACK_TECHNIQUES, WEB_COMPONENT_WIDGET_NETWORK_ATTACK_TECHNIQUES],
      [WidgetType.ENDPOINT_MODULES_STATUS_DETAILS, WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS_DETAILS],
    ]);
  }
}
